// extracted by mini-css-extract-plugin
export default {"host":"style_host__A0fm9","email":"style_email__S1u0Y"};